<template lang="pug">
.lang
  template(v-if="isAuthed")
    i.icon-lang
    span.language {{ $t('header.language') }}
  .lang-inner
    span.lang__item(
      v-for="lang in languageArray"
      :key="lang"
      :class="{'lang__item--active': lang === selectedLang.toLowerCase()}"
      @click="handleChooseLang(lang)"
    ) {{ lang }}
</template>
<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'

export default {
  name: 'Language',
  data() {
    return {
      languageArray: ['ua', 'ru']
    }
  },
  computed: {
    ...mapState({
      selectedLang: state => state.profile.clientProfile.language
    }),
    ...mapGetters(['isAuthed'])
  },
  watch: {
    selectedLang(lang) {
      if (!lang) return
      const stored = localStorage.getItem('lang')
      if (!stored || stored === 'null') return
      if (lang.toLowerCase() === stored.toLowerCase()) return
      this.handleChooseLang(stored)
    }
  },
  methods: {
    ...mapActions(['patchClientSettings']),
    ...mapMutations({
      setDataProfile: 'SET_DATA_PROFILE'
    }),
    async handleChooseLang(lang) {
      if (this.$i18n.locale !== lang) {
        this.$i18n.locale = lang
        localStorage.setItem('lang', lang)
      }

      const upperLang = lang.toUpperCase()
      if (this.selectedLang && this.selectedLang.toUpperCase() === upperLang) return

      if (this.isAuthed) {
        await this.patchClientSettings({ body: { language: upperLang } })
      } else {
        this.setDataProfile({ clientProfile: { language: lang } })
      }
    }
  }
}
</script>
